import { Box, BoxProps } from '@mui/material';

const IconFaceFrame = ({ ...other }: BoxProps) => {
  return (
    <Box {...other}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 100 100"
        fill="none"
      >
        <line x1="10" y1="25" x2="10" y2="10" stroke="#3E4B57" stroke-width="1" />
        <line x1="10" y1="10" x2="25" y2="10" stroke="#3E4B57" stroke-width="1" />

        <line x1="90" y1="25" x2="90" y2="10" stroke="#3E4B57" stroke-width="1" />
        <line x1="75" y1="10" x2="90" y2="10" stroke="#3E4B57" stroke-width="1" />

        <line x1="10" y1="90" x2="10" y2="75" stroke="#3E4B57" stroke-width="1" />
        <line x1="10" y1="90" x2="25" y2="90" stroke="#3E4B57" stroke-width="1" />

        <line x1="90" y1="90" x2="90" y2="75" stroke="#3E4B57" stroke-width="1" />
        <line x1="75" y1="90" x2="90" y2="90" stroke="#3E4B57" stroke-width="1" />
      </svg>
    </Box>
  );
};

export default IconFaceFrame;
